// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p-WWI","label":"styles_label__6pHAT"};